interface UpdateItem {
  date: string;
  tag: string;
  title: string;
  summary: string;
}

interface MediaItem {
  title: string;
  duration: string;
  views: string;
  tag: string;
  imageUrl: string;
}

interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

interface CommentItem {
  name: string;
  time: string;
  content: string;
  likes: number;
}

interface TopicItem {
  name: string;
  count: string;
  hot: boolean;
}

interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  change: string;
}

interface IndexItem {
  title: string;
  desc: string;
  count: string;
  tag: string;
}

interface CarouselItem {
  title: string;
  subtitle: string;
  desc: string;
  tag: string;
  imageUrl: string;
}

interface CardItem {
  title: string;
  desc: string;
  tag: string;
  date: string;
  imageUrl: string;
}

interface FaqItem {
  q: string;
  a: string;
}

export const updates: UpdateItem[] = [
  { date: '07-30', tag: '最新爆料', title: '某顶流男星深夜私会网红被拍，工作室火速回应', summary: '据知情人士透露，该男星近期频繁出入某高档小区，与一位知名网红关系密切。相关视频已在平台疯传，引发粉丝强烈讨论。' },
  { date: '07-29', tag: '娱乐圈', title: '知名导演新片选角内幕曝光，多位艺人卷入争议', summary: '一份据称来自剧组内部的选角名单流出，涉及多位一线艺人。制片方尚未正面回应，但已有相关方表示将通过法律途径维权。' },
  { date: '07-29', tag: '网红圈', title: '千万粉丝主播涉嫌虚假宣传，消费者集体投诉', summary: '多名消费者反映在某头部主播直播间购买的商品与宣传严重不符，目前已向市场监管部门提交举报材料，涉及金额超百万元。' },
  { date: '07-28', tag: '热榜追踪', title: '某综艺节目录制现场冲突画面流出', summary: '一段录制现场的偷拍视频显示，两位常驻嘉宾在节目间隙发生激烈争执，节目组目前尚未对事件做出官方说明。' },
  { date: '07-28', tag: '社会热点', title: '某知名企业高管被曝婚内出轨，当事人社交账号清空', summary: '一组亲密照在网络流传，涉事高管已关闭所有社交平台账号。该公司股价次日开盘下跌超过3%，董事会紧急召开会议。' },
  { date: '07-27', tag: '最新爆料', title: '选秀节目选手背景造假风波持续发酵', summary: '多位选手被扒出学历造假、年龄造假等问题，节目官方微博评论区已被网友攻陷，制作方面临巨大舆论压力。' },
  { date: '07-27', tag: '娱乐圈', title: '某女星离婚协议细节遭曝光，财产分割引争议', summary: '一份据称是离婚协议的文件在网上流传，显示女方获得了多处房产和巨额赡养费，引发网友对其婚姻动机的质疑。' },
  { date: '07-26', tag: '网红圈', title: '头部主播团队内讧，合伙人发长文控诉', summary: '该主播的前合伙人在社交平台发布数千字长文，爆料公司内部财务管理混乱、利益分配不公等问题，双方各执一词。' },
];

export const mediaItems: MediaItem[] = [
  { title: '独家实拍：某女星深夜与神秘男子同返公寓', duration: '03:42', views: '128.6万', tag: '独家', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20atmosphere%20and%20warm%20lighting%2C%20mysterious%20mood%2C%20abstract%20storytelling%20composition%2C%20professional%20photography%20style%2C%20soft%20shadows%2C%20no%20text%20or%20people&width=640&height=360&seq=media-vid-01&orientation=landscape' },
  { title: '圈内人爆料：某综艺后台不为人知的潜规则', duration: '08:15', views: '96.3万', tag: '爆料', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20atmosphere%20and%20warm%20lighting%2C%20mysterious%20mood%2C%20abstract%20storytelling%20composition%2C%20professional%20photography%20style%2C%20soft%20shadows%2C%20no%20text%20or%20people&width=640&height=360&seq=media-vid-02&orientation=landscape' },
  { title: '实锤来了！某网红造假全过程完整复盘', duration: '12:08', views: '215.7万', tag: '实锤', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20atmosphere%20and%20warm%20lighting%2C%20mysterious%20mood%2C%20abstract%20storytelling%20composition%2C%20professional%20photography%20style%2C%20soft%20shadows%2C%20no%20text%20or%20people&width=640&height=360&seq=media-vid-03&orientation=landscape' },
  { title: '独家对话知情人士：某事件真相大揭秘', duration: '05:30', views: '87.2万', tag: '独家', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20atmosphere%20and%20warm%20lighting%2C%20mysterious%20mood%2C%20abstract%20storytelling%20composition%2C%20professional%20photography%20style%2C%20soft%20shadows%2C%20no%20text%20or%20people&width=640&height=360&seq=media-vid-04&orientation=landscape' },
];

export const features: FeatureItem[] = [
  { icon: 'ri-flashlight-line', title: '实时追踪', desc: '7×24小时全天候追踪娱乐圈、网红圈最新黑料动态，第一时间推送热门事件，不错过任何精彩内容。' },
  { icon: 'ri-shield-check-line', title: '多方核实', desc: '每条爆料均经过多渠道交叉验证，确保信息来源可靠，为用户提供经得起推敲的优质黑料内容。' },
  { icon: 'ri-vidicon-line', title: '高清视频', desc: '独家实拍高清视频资源，流畅播放不卡顿，支持多种分辨率选择，带来极致观看体验。' },
  { icon: 'ri-group-line', title: '社区互动', desc: '活跃的吃瓜社区，百万用户在线讨论，分享观点、交流心得，一起追踪最新国产黑料事件。' },
  { icon: 'ri-lock-line', title: '隐私保护', desc: '采用先进的隐私保护技术，用户浏览记录严格保密，让你安心畅享黑料内容，无后顾之忧。' },
];

export const comments: CommentItem[] = [
  { name: '吃瓜路人甲', time: '2小时前', content: '这个料也太猛了吧！没想到他私下居然是这样的人，之前的人设完全崩塌了。', likes: 2836 },
  { name: '娱乐圈观察家', time: '5小时前', content: '作为从业十年的媒体人，我可以负责任地说这里面水很深，爆出来的只是冰山一角而已。', likes: 1921 },
  { name: '理性吃瓜群众', time: '8小时前', content: '建议大家不要急着站队，先让子弹飞一会儿。现在信息太杂，真假难辨，理性吃瓜最重要。', likes: 1567 },
  { name: '追剧小达人', time: '12小时前', content: '就是因为这些乱七八糟的事情，好多好看的剧都延期了，心疼我们这些单纯的观众啊。', likes: 1102 },
  { name: '八卦研究员', time: '1天前', content: '已经整理好了时间线和人物关系图，关注我首页自取。这瓜保熟，大家放心食用！', likes: 975 },
];

export const topics: TopicItem[] = [
  { name: '顶流塌房', count: '326万讨论', hot: true },
  { name: '明星恋情曝光', count: '218万讨论', hot: true },
  { name: '综艺黑幕', count: '187万讨论', hot: true },
  { name: '网红翻车', count: '165万讨论', hot: false },
  { name: '选秀内定', count: '143万讨论', hot: false },
  { name: '剧组八卦', count: '128万讨论', hot: false },
  { name: '直播带货维权', count: '106万讨论', hot: true },
  { name: '艺人解约风波', count: '95万讨论', hot: false },
  { name: '娱乐圈税务', count: '82万讨论', hot: false },
];

export const rankings: RankItem[] = [
  { rank: 1, title: '某顶流男星深夜私会网红完整视频流出', tag: '爆', heat: '985.3万', change: 'up' },
  { rank: 2, title: '知名导演选角内幕：多位一线艺人牵涉其中', tag: '热', heat: '762.1万', change: 'up' },
  { rank: 3, title: '千万主播虚假宣传事件：消费者集体诉讼', tag: '热', heat: '654.8万', change: 'up' },
  { rank: 4, title: '综艺录制现场冲突：两位常驻嘉宾大打出手', tag: '新', heat: '543.2万', change: 'new' },
  { rank: 5, title: '某企业高管婚内出轨：亲密照全网疯传', tag: '热', heat: '432.7万', change: 'down' },
  { rank: 6, title: '选秀选手学历造假：节目组面临制作危机', tag: '', heat: '321.5万', change: 'down' },
  { rank: 7, title: '某女星天价离婚协议细节曝光引全网热议', tag: '', heat: '287.9万', change: 'up' },
];

export const indexItems: IndexItem[] = [
  { title: '娱乐圈爆料合集', desc: '收录近期最火爆的娱乐圈黑料事件，从顶流塌房到幕后潜规则，一网打尽。', count: '156篇', tag: '热门' },
  { title: '网红圈翻车实录', desc: '盘点各大网红主播翻车名场面，虚假宣传、人设崩塌、团队内讧全记录。', count: '89篇', tag: '推荐' },
  { title: '综艺节目爆料专区', desc: '选秀内幕、录制事故、嘉宾矛盾，综艺节目背后的真实故事都在这里。', count: '124篇', tag: '热门' },
  { title: '明星情感八卦专题', desc: '明星恋情、婚姻、分手、复合，关注娱乐圈最引人瞩目的情感动态。', count: '203篇', tag: '热门' },
  { title: '直播带货打假', desc: '曝光直播带货中的虚假宣传和质量问题，保护消费者权益，揭露行业乱象。', count: '67篇', tag: '推荐' },
  { title: '影视圈内幕揭秘', desc: '从剧组潜规则到制片方内斗，揭开影视行业光鲜表面下的真实生态。', count: '98篇', tag: '' },
  { title: '社会热点事件追踪', desc: '跳出娱乐圈，关注更广泛的社会热点事件，全面覆盖各类黑料内容。', count: '145篇', tag: '' },
];

export const carouselItems: CarouselItem[] = [
  { title: '顶流塌房全记录', subtitle: '2026上半年娱乐圈大地震', desc: '多位一线明星接连翻车，从私生活混乱到税务问题，娱乐圈经历了前所未有的信任危机。本专题全面梳理事件脉络，还原真相。', tag: '重磅专题', imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20deep%20red%20and%20black%20tones%2C%20theatrical%20spotlight%20on%20an%20empty%20stage%2C%20mysterious%20atmosphere%2C%20elegant%20composition%2C%20professional%20editorial%20photography%2C%20dark%20background%20with%20warm%20accents%2C%20no%20people%20or%20text&width=720&height=480&seq=carousel-01&orientation=landscape' },
  { title: '网红圈洗牌年', subtitle: '从风光无限到集体翻车', desc: '头部主播接连出事，虚假宣传、数据造假、团队分裂，曾经风光无限的网红经济正在经历最严峻的考验。', tag: '深度报道', imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20deep%20amber%20and%20dark%20tones%2C%20abstract%20storytelling%20composition%2C%20mysterious%20atmosphere%2C%20professional%20editorial%20photography%2C%20dark%20background%20with%20warm%20accents%2C%20no%20people%20or%20text&width=720&height=480&seq=carousel-02&orientation=landscape' },
  { title: '综艺节目暗面', subtitle: '镜头背后的真实故事', desc: '选秀内定、剧本操控、嘉宾冲突，当聚光灯熄灭后，综艺节目的真实面貌远比屏幕上的更加精彩和复杂。', tag: '独家策划', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20crimson%20and%20black%20tones%2C%20backstage%20theater%20atmosphere%2C%20mysterious%20mood%2C%20professional%20editorial%20photography%2C%20no%20people%20or%20text&width=720&height=480&seq=carousel-03&orientation=landscape' },
  { title: '2026吃瓜年鉴', subtitle: '值得铭记的年度十大事件', desc: '回顾过去一年最具影响力的黑料事件，从年初的惊天大瓜到最近的热门话题，每一件都曾引爆全网讨论。', tag: '年度盘点', imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20dramatic%20scene%20with%20warm%20golden%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20sophisticated%20composition%2C%20abstract%20storytelling%2C%20professional%20editorial%20photography%2C%20no%20people%20or%20text&width=720&height=480&seq=carousel-04&orientation=landscape' },
  { title: '真相追踪者', subtitle: '揭秘黑料背后的产业链', desc: '深入调查黑料内容的生产、传播和变现链条，揭示这个庞大而隐秘的灰色产业是如何运作的。', tag: '调查报道', imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20dramatic%20scene%20with%20deep%20charcoal%20and%20warm%20red%20accents%2C%20investigative%20atmosphere%2C%20cinematic%20lighting%2C%20abstract%20composition%2C%20professional%20editorial%20photography%2C%20no%20people%20or%20text&width=720&height=480&seq=carousel-05&orientation=landscape' },
];

export const cardItems: CardItem[] = [
  { title: '独家还原：某综艺节目后台冲突全过程', desc: '多方信源交叉验证，还原录制当天发生的真实情况，此前流传的多个版本均与事实存在出入。', tag: '独家', date: '2026-07-30', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20crimson%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-01&orientation=landscape' },
  { title: '深度分析：网红经济为何频频翻车', desc: '从商业模式、监管缺失、从业者素质等多个维度，剖析网红圈乱象背后的深层原因。', tag: '分析', date: '2026-07-29', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20amber%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-02&orientation=landscape' },
  { title: '时间线整理：某顶流艺人塌房事件全回顾', desc: '从事件最初曝光到最新进展，完整梳理每一个关键节点，帮助读者全面把握事件全貌。', tag: '整理', date: '2026-07-28', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20crimson%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-03&orientation=landscape' },
  { title: '知情人士专访：揭开娱乐圈选角潜规则', desc: '一位匿名的资深选角导演接受专访，详细披露了行业内不为人知的选角操作手法。', tag: '专访', date: '2026-07-27', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20golden%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-04&orientation=landscape' },
  { title: '对比盘点：2026年上半年塌房艺人排行榜', desc: '从事件严重程度、舆论反应、商业损失等多维度，对上半年塌房事件进行综合排名分析。', tag: '盘点', date: '2026-07-26', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20crimson%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-05&orientation=landscape' },
  { title: '法律视角：明星隐私权与公众知情权的边界', desc: '邀请法律专家解读，在吃瓜的同时如何把握法律边界，避免从围观者变成侵权者。', tag: '科普', date: '2026-07-25', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20amber%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-06&orientation=landscape' },
  { title: '海外视点：外媒如何看待中国娱乐圈乱象', desc: '整理海外媒体对中国娱乐圈近期事件的报道和评论，呈现不同文化视角下的观察与思考。', tag: '视点', date: '2026-07-24', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20golden%20and%20charcoal%20tones%2C%20abstract%20composition%2C%20professional%20photography%2C%20mysterious%20atmosphere%2C%20no%20text%20or%20people&width=640&height=420&seq=card-img-07&orientation=landscape' },
];

export const faqItems: FaqItem[] = [
  { q: '17黑料网的内容来源是否可靠？', a: '17黑料网所有内容均来自公开网络信息和多方信源交叉验证。我们建立了严格的内容审核机制，确保每一条信息都经过核实后再发布。对于暂未完全证实的信息，我们会明确标注"待核实"标签，建议用户理性看待。' },
  { q: '如何第一时间获取最新黑料更新？', a: '您可以将17黑料网添加到浏览器收藏夹，或关注我们的社交媒体账号。我们每天保持高频更新，重要事件发生后会在30分钟内完成信息整理和发布，确保您不错过任何热门吃瓜内容。' },
  { q: '国产黑料视频播放需要付费吗？', a: '17黑料网所有国产黑料视频内容均免费在线观看，无需注册或付费。我们提供高清流畅的播放体验，支持多种设备访问，让用户随时随地畅享最新国产黑料视频资源。' },
  { q: '网站上的视频为什么会加载失败？', a: '视频加载失败通常由网络环境或服务器高峰期导致。建议您尝试刷新页面、切换网络环境或避开访问高峰期。如果问题持续存在，请通过联系入口向我们反馈，技术团队会尽快处理。' },
  { q: '如何区分真实的黑料和虚假信息？', a: '我们建议用户关注信息的多方验证情况。17黑料网会对每条内容标注核实状态：绿色标签表示多方验证属实，黄色标签表示部分属实，灰色标签表示仍在核实中。请用户结合多方信息理性判断。' },
  { q: '17黑料网与其它黑料平台有什么不同？', a: '17黑料网专注于国产黑料内容的深度整合，相比其他平台，我们在内容覆盖面、更新频率、视频清晰度和社区活跃度方面都具有明显优势。我们致力于打造最全面、最及时的国产黑料在线观看平台。' },
];